import { http, largeFileConfig } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@/core/models/ApiResource.interface';
import { LocationQuery } from 'vue-router';
import { Certificate, CertificateDTO } from './certificate.interface';

export class CertificateService {
   async getCertificates(employeeId: number, query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<Certificate>>>(`/employees/${employeeId}/certificates`, { params: { ...query } });
      return response.data;
   }

   async getCertificate(employeeId: number, certificateId: number) {
      const response = await http.get<Certificate>(`/employees/${employeeId}/certificates/${certificateId}`);
      return response.data;
   }

   async postCertificate(employeeId: number, certificateDTO: CertificateDTO) {
      const formData = new FormData();

      Object.entries(certificateDTO).forEach(([key, value]) => {
         formData.append(key, value);
      });

      const response = await http.post<Certificate>(`/employees/${employeeId}/certificates`, formData, largeFileConfig);
      return response.data;
   }

   async putCertificate() {
      throw Error('Method not implemented');
   }

   async deleteCertificate(employeeId: number, certificateId: number) {
      const response = await http.delete(`/employees/${employeeId}/certificates/${certificateId}`);
      return response.data;
   }
}
